/**
 * @file components/audit-tasks/phases/field-tabs.ts
 * @description 現場稽核（PhaseField）Tabs 的鍵值常量與 URL search 解析工具。
 *
 * 2026-09-13 回報序21：表單填寫頁「返回任務」原本只帶回階段（?phase=field），
 * 現場稽核的 Tabs 一律回到第一個「打卡」頁籤——從「稽核文件包」填表返回時位置錯誤。
 * 現改為表單入口額外帶 `fromTab`，返回時以 `?tab=` 指定 PhaseField 初始頁籤。
 */

/** 現場稽核四個頁籤：打卡 / 稽核文件包 / 採樣送檢 / NC 紀錄 */
export const FIELD_TABS = ['gps', 'forms', 'sampling', 'findings'] as const;

/** 現場稽核頁籤鍵 */
export type FieldTab = (typeof FIELD_TABS)[number];

/**
 * 將任意 URL search 值收斂為合法頁籤鍵；非法值回 undefined（由呼叫端回落預設頁籤）。
 *
 * @param value URL search 中的原始值
 * @returns 合法的 FieldTab 或 undefined
 */
export function parseFieldTab(value: unknown): FieldTab | undefined {
  return FIELD_TABS.includes(value as FieldTab) ? (value as FieldTab) : undefined;
}
